import { render, staticRenderFns } from "./createSeats.vue?vue&type=template&id=a7152d86"
import script from "./createSeats.vue?vue&type=script&lang=js"
export * from "./createSeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports